import { useMemo } from 'react';

type UseFilteredParams<T extends {}> = {
  nodes: T[];
  filters?: { [x in keyof T]?: unknown };
  keys?: (keyof T)[];
};

export const useFiltered = <T extends {}>({
  nodes,
  filters,
  keys,
}: UseFilteredParams<T>) => {
  const result = useMemo(() => {
    if (!filters || !keys) return nodes;

    const filterByKeys = keys || (Object.keys(filters) as (keyof T)[]);
    const satisfies = (node: T) => {
      return filterByKeys.every(key => {
        const filterValue = filters[key];
        return filterValue === undefined || node[key] === filterValue;
      });
    };

    return (nodes || []).filter(node => satisfies(node));
  }, [nodes, filters, keys]);

  return result;
};
